import { lazy } from 'react';

const BadgeDetailsModal = lazy(
  () => import('modules/DigitalBadges/modals/BadgeDetailsModal'),
);

const BadgeFaqModal = lazy(
  () => import('modules/DigitalBadges/modals/BadgeFaqModal'),
);

export default {
  BADGE_DETAILS_MODAL: BadgeDetailsModal,
  BADGE_FAQ_MODAL: BadgeFaqModal,
};
